import ArticlesAdminTemplate from "components/templates/ArticlesAdminTemplate/ArticlesAdminTemplate";

const ArticlesAdminPage = () => {
  return <ArticlesAdminTemplate />;
};

export default ArticlesAdminPage;
